// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"400":"df31feb17cc0a337","601":"a97e99318d4a93dd","708":"89746a3f4ffe334a"}[chunkId] + ".js";
};